import { Box, Flex } from '@chakra-ui/react';

import { Badge, Button, Typography, useColorMode } from 'shared';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';

import { SIZES } from 'shared/components/Modal';

import { ScheduleIcon } from './ScheduleIcon';

type ScheduleListHeaderProps = {
  onClose: () => void;
};

export const ScheduleListHeader = ({ onClose }: ScheduleListHeaderProps) => {
  const { colorMode } = useColorMode();
  const isLightTheme = colorMode === 'light';
  const color = isLightTheme ? 'blue' : 'white';
  const typographyColor = isLightTheme ? 'blue' : 'whiteTotal';

  return (
    <Flex
      alignItems="center"
      h={8}
      position="sticky"
      top={0}
      bg="var(--bgSecondary)"
      zIndex={11}
    >
      <Box flex={1}>
        <Button
          onClick={onClose}
          aria-label="back button"
          _focusVisible={{
            outline: 'none',
          }}
          colorPalette={color}
          variant="ghost"
        >
          <Icon name={iconNames.arrowLeft} stroke={color} /> Back
        </Button>
      </Box>
      <Badge colorPalette="lightBlue" size={SIZES.SM}>
        <Flex gap="var(--spacing02)" alignItems="center">
          <ScheduleIcon
            withDot
            dotColor={color}
            iconColor={color}
            size="22px"
          />
          <Typography type="meta" fontWeight="medium" color={typographyColor}>
            Scheduled messages
          </Typography>
        </Flex>
      </Badge>
      <Box flex={1} />
    </Flex>
  );
};
